import { Spinner, Table, Card } from "react-bootstrap";
import { useItems } from "../../api/items.query";
import { CreateItemButton } from "./CreateItemButton";
import { ItemTableRow } from "./ItemTableRow";

interface ItemTableProps {
  warehouseId?: string;
}

export const ItemTable = ({ warehouseId }: ItemTableProps) => {
  const { data, error, isLoading } = useItems(warehouseId);

  if (isLoading) {
    return <Spinner />
  }

  if (error) {
    return <Card>
      {error.name}: {error.message}
    </Card>
  }

  if (!data || !data.items || data.items.length === 0) {
    return <Card>
      No Items!
      <CreateItemButton />
    </Card>
  }

  return <Card style={{ width: '100%' }}>

    <Card.Body>
      <Table>
        <thead>
          <tr>
            <th>Item</th>
            <th className="d-none d-sm-table-cell">Warehouse</th>
            <th>Quantity</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data?.items?.map((item) => (
            <ItemTableRow item={item} key={item.id} />
          ))}
        </tbody>
      </Table>
    </Card.Body>
    <Card.Footer>
      <CreateItemButton />
    </Card.Footer>
  </Card>
}

